import WorthyApi from 'lib/api/worthyApi';

export const GET_USER_BUNDLES = Symbol();
export const GET_BUNDLE_WITH_ITEMS = Symbol();
export const CLEAR_SELECTED_BUNDLE = Symbol();
export const ACCEPT_BUNDLE_SALE = Symbol();
export const ABORT_ITEM = Symbol('ABORT_ITEM');

export function getUserBundles(userId){
    let request =
        WorthyApi.getUserBundles(userId).then((res)=> {
            return res.data;
        });
    return {
        type:       GET_USER_BUNDLES,
        payload:    request
    }
}

export function clearSelectedBundle() {
    return {
        type:       CLEAR_SELECTED_BUNDLE
    }
}

export function getBundleWithItems(bundleId){
    let request =
        WorthyApi.getBundleWithItems(bundleId).then(
            (res) => {
                return res.data;
            },
            (err) => {
                return err;
            });
    return {
        type:       GET_BUNDLE_WITH_ITEMS,
        payload:    request
    }
}

export function acceptBundleSale(bundleId) {
    let request =
        WorthyApi.acceptBundleSale(bundleId).then(
            (res) => {
                return res.data;
            },
            (err) => {
                return err;
            });
    return {
        type:       ACCEPT_BUNDLE_SALE,
        payload:    request
    }
}

export function abortItem(id){
    let request =
        WorthyApi.abortItem(id)
            .then((res) => {
             return res;
            })
            .catch((error) => {
               return error;
            });
    return {
        type:       ABORT_ITEM,
        payload:    request
    }

}
